<template>
<li>
  <div class="faqTitleLine">
    <p>{{item.title}}</p>
    <div v-on:click="toogleDesc" v-bind:class="{active:openItem}" class="pointerFaqItem">
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-html="item.desc" class="faqDesc" v-bind:class="{active:openItem}"></div>
</li>
</template>

<script>
export default {
  name: "faqItem",
  props:{
    item:{
      type:Object,
      default(){
        return {
          title:'',
          desc:''
        }
      }
    }
  },
  data(){
    return {
      openItem:false,
    }
  },
  methods:{
    toogleDesc(){
      this.openItem = !this.openItem;
    }
  }
}
</script>

<style scoped>
li{font-size: var(--font-size-20);color:var(--color-black-type2);margin: 0 0 var(--font-size-20)}

.faqTitleLine{display: flex;align-items: center;justify-content: space-between}
.faqTitleLine p{width: calc(100% - var(--font-size-20))}
.pointerFaqItem{width: var(--font-size-16);height: var(--font-size-16);cursor: pointer;position: relative;}
.pointerFaqItem div{width: 100%;height: var(--font-size-02);border-radius: var(--font-size-02);position: absolute;left:0;top:calc(50% - var(--font-size-01));background: var(--color-black-type2)}
.pointerFaqItem div:first-child{transform: rotate(90deg);transition: 0.3s ease-out}
.pointerFaqItem.active div:first-child{transform: rotate(0deg)}
.pointerFaqItem div:last-child{}
.faqDesc{font-weight: 400;opacity: 0;height: 0;transition:  0.3s ease-out;margin: 0 }
.faqDesc.active{opacity: 1;height: auto;margin:var(--font-size-20) 0 }

@media screen and (min-width: 760px) {
  li{width: var(--font-size-515)}
}
</style>